quoteModule.controller('quoteContractInfoController', ['$rootScope', '$scope', 'contractInfoService', 'rateQuoteCoordService',
    'quoteContractRetrievalService', 'quoteCreationEvents', 'contractCreationService', '$mdDialog', 'rateQuoteRetrievalCoordService',
    'rateQuotePersistService', 'locationService', 'TLCError','AppErrorCodes','erateSessionVarsService', 'quoteIntegrationConstants','vehicleTypeConstants','imSessionVarsService',
    'quoteIntegrationService', 'rateQuoteScenariosService', '$timeout',
    function($rootScope, $scope, contractInfoService, rateQuoteCoordService,
             quoteContractRetrievalService, quoteCreationEvents, contractCreationService, $mdDialog, rateQuoteRetrievalCoordService,
             rateQuotePersistService, locationService, TLCError, AppErrorCodes, erateSessionVarsService, quoteIntegrationConstants, vehicleTypeConstants, imSessionVarsService,
             quoteIntegrationService, rateQuoteScenariosService, $timeout) {
        $scope.contractProductInfo = contractInfoService.contractProductInfo;

        $scope.customerDefinition = rateQuoteCoordService.CustomerData;
        $scope.lenderInfo = rateQuoteCoordService.LenderData;
        $scope.dealInfo = rateQuoteCoordService.DealData;
        $scope.vehicleInfo = rateQuoteCoordService.VehicleData;
        $scope.contractProcessingCI = contractCreationService.contractProcessing;

        $scope.error = this.error; // e.g. { reason: 'Service not found', status: '404' }
        var override = function() { return !!$scope.error; };
        $scope.override = override;

        $scope.isAllPerformancePointsSectionReady = false;
        $scope.isPerformancePointsSelectTextEnabled = false;
        $scope.isAmountFinancedEnabled = false;
        $scope.isEtchStencilNumEnabled = false;
        $scope.isEtchNumEnabled = false;
        $scope.isEtchSecNumEnabled = false;
        $scope.isKeycareContractNumEnabled = false;
        $scope.etchStencilLabel = 'ETCH STENCIL';

        $scope.init = function() {
            rateQuoteRetrievalCoordService.endQuoteRetrieval();
            $scope.getPerfPointsUIMode();
            getSelectTextPerformancePoint();
            getEnabledPrFltFields();

            $scope.contractProductInfo.keycareContractNum = $scope.contractProductInfo.keycareContractNum || "";// has to be a string
            var prefix = $scope.contractProductInfo.keycareContractPrefix || "";
            var min = $scope.contractProductInfo.keycareContractLength,
                max = min;
            $scope.keycareValidationParameters = [prefix, "0-9A-Za-z", min, max].join(",");

            //Determining what view will be shown first based on completion
            var missingInfoViewComplete = !($scope.shouldShowNameFields() || $scope.shouldEnableAddressFields() || $scope.shouldEnableKeycareField() || $scope.shouldEnableEtchStencilField() || $scope.shouldEnableEtchNumberField() || $scope.shouldEnableSellingPrice() || $scope.shouldEnableRVFields() || $scope.shouldEnableAmountFinanced() || $scope.isAmountFinancedEnabled );
            var lenderInfoViewComplete = ($scope.lenderInfo.selectedLender != 'Nan' && $scope.lenderInfo.selectedLender != null) ? true : false;
            var performancePointViewComplete = ($scope.isPerformancePointsSelectTextEnabled ? ($scope.shouldEnablePerformancePointsSelect() || $scope.shouldEnablePerformancePointsText()) || $scope.showCheckedPerformancePoints() : true);
            activeView = GetActiveView(missingInfoViewComplete, lenderInfoViewComplete, performancePointViewComplete);
        };

        $scope.preflightViews = {
            missingInfo: "missingInfo",
            LenderInfo: "LenderInfo",
            performancePoint: "performancePoint",
            lenderView: rateQuoteCoordService.LenderData.selectedLender
        };

        $scope.IsGap = CheckGap();
        $scope.IsKey = CheckKey();
        $scope.IsEtch = CheckProdEtch();
        $scope.etchStencilLabel = GetThftContractLabel() || $scope.etchStencilLabel;


        function getFlexField(container, fieldName) {
            var flexFields = container // container object assumed to have PartnerSpecificFields
                && container.PartnerSpecificFields
                && container.PartnerSpecificFields.FlexFields;

            if (!angular.isArray(flexFields))
                return angular.undefined;

            var field = _.find(flexFields, function (fieldObj) { return fieldObj.FieldName === fieldName});

            return field && field.FieldValue;  // may be undefined
        }

        var activeView = $scope.preflightViews.missingInfo;

        $scope.setActiveView  = function (viewName) {
            activeView = viewName;
            console.log("activeView", activeView);
        };

        $scope.isViewActive = function(viewName) {
            return activeView === viewName;
        };


        $scope.preflightHide = function() {
            $mdDialog.hide();
        };

        $scope.isAllDataCheck = function(){
            if ($scope.isPerformancePointsSelectTextEnabled){ //means we are a provider with preformancepoints (F&I Manager)
                return ($scope.isAllMissingInfoReady() && $scope.lenderInfo.selectedLender && $scope.showCheckedPerformancePoints());

            }
            else{
                return $scope.isAllMissingInfoReady() && $scope.lenderInfo.selectedLender
            }
        }

        $scope.showCheckedPerformancePoints= function(){
            return ($scope.isPerformancePointsSelectTextEnabled && contractInfoService.contractProductInfo.performancePoints != null //Select
                    && contractInfoService.contractProductInfo.performancePoints != "" && contractInfoService.contractProductInfo.performancePoints != undefined)
                || ($scope.isPerformancePointsSelectTextEnabled && contractInfoService.contractProductInfo.performancePoints1 != null //Text
                    && contractInfoService.contractProductInfo.performancePoints1 != "" && contractInfoService.contractProductInfo.performancePoints1 != undefined
                    && contractInfoService.contractProductInfo.performancePoints2 != null && contractInfoService.contractProductInfo.performancePoints2 != ""
                    && contractInfoService.contractProductInfo.performancePoints2 != undefined);

        };

        $scope.preflightCancel = function() {

               $scope.contractProductInfo.keycareContractNum = $scope.contractProductInfo.keycareContractNum || "";
                rateQuotePersistService.saveRatesAsQuotes()
                    .then(
                        function (data) {
                            $mdDialog.cancel();
                            var quoteIds = contractInfoService.quoteQueueInfo.selectedQuotes;
                            if (quoteIds && quoteIds.length > 0) {
                                quoteIds.forEach(function (quoteId) {
                                    contractInfoService.quoteQueueInfo.loading[quoteId] = false;
                                });
                            }
                            quoteIds = null;//cleanup
                        });
               };

        $scope.finishContracting = function() {
            rateQuotePersistService.saveRatesAsQuotes()
                .then(
                function(data){

                    //check our quoting mode (integrated or not)
                    var quoteMode = erateSessionVarsService.getQuotingMode();
                    if (quoteMode && quoteMode.toUpperCase() == quoteIntegrationConstants.menuContractIntegrated){
                        //Transfer preflight info back to menu
                        $scope.transferQuotesToIntegratedApp('MENUPRO');
                    }

                    var quoteIds = [];
                    if (contractInfoService.quoteQueueInfo.selectedQuotes && contractInfoService.quoteQueueInfo.selectedQuotes.length > 0)
                        quoteIds = contractInfoService.quoteQueueInfo.selectedQuotes;

                    var dateOfSale = new Date();
                    if (rateQuoteCoordService.VehicleData && rateQuoteCoordService.VehicleData.dateOfSale)
                        dateOfSale = new Date(rateQuoteCoordService.VehicleData.dateOfSale);

                    contractCreationService.attemptCreateContract(quoteIds, dateOfSale, true)
                        .then(
                                function() {
                                    quoteIds.forEach(function(quoteId) {
                                        contractInfoService.quoteQueueInfo.loading[quoteId] = false;
                                        contractCreationService.setCreationStatus(quoteId,null); //clear it out
                                    });
                                    $rootScope.$broadcast(quoteCreationEvents.refreshQuoteQueue, {});
                                },
                                function(error) {
                                    if(error === contractCreationService.requiredFieldsMissingError) {
                                        throw new TLCError(new Error('Supposed to be done but still missing info... Aborting with: ' + error),AppErrorCodes.QuoteContractController_MissingInfoError);
                                    } else {
                                        quoteIds.forEach(function(quoteId) {
                                            contractInfoService.quoteQueueInfo.loading[quoteId] = false;
                                        });

                                        $mdDialog.show( {
                                            templateUrl: 'app/modules/quote/views/preflight-dialog.html',
                                            scope: $scope,
                                            preserveScope: true,
                                            locals: { error: error },
                                            bindToController: true,
                                            controller: 'quoteContractInfoController'

                                        });
                                        throw new TLCError(new Error(error),AppErrorCodes.QuoteContractController_ContractCreateError);
                                    }
                                }
                            );
                },
                function(err){
                    throw new TLCError(new Error(err),AppErrorCodes.QuoteContractController_ContractCreateError);
                });
        };

        //send quote info to MenuPro (or another app later)
        $scope.transferQuotesToIntegratedApp = function(applicationCode){

            $rootScope.$broadcast(quoteCreationEvents.queueUpIntegration,{});

            //if the user is clicking quickly thru
            // quotes, let's wait and see if they add more
            // quotes within 5 seconds. If they do, cancel the first
            // time-delayed transmit and start another.
            if ($scope.integrationTimerPromise) {
                $timeout.cancel($scope.integrationTimerPromise);
            }
            $scope.integrationTimerPromise = $timeout(
                function delaySendToIntegratedApp(){
                    //prepare the data for trasmission
                    $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: false});

                    quoteIntegrationService.prepDataForIntegrationSubmit(
                        rateQuoteCoordService.CustomerData,
                        rateQuoteCoordService.VehicleData,
                        rateQuoteCoordService.DealData,
                        rateQuoteCoordService.getHeldQuotesPerProposal(),
                        rateQuoteScenariosService.getScenarioList())
                        .then(
                            function quoteDataReady(preparedIntegrationData) {
                                //send the "quote data" back to the integrated APP
                                // MENUPRO is the default for now
                                quoteIntegrationService.signalIntegrationSendToApp(
                                    erateSessionVarsService.getIntegrationToken(),
                                    applicationCode,
                                    preparedIntegrationData)
                                    .then(
                                        function transferSuccess(ok){
                                            $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: true});
                                        },
                                        function transferErr(err){
                                            $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: true});
                                            throw new TLCError(new Error(err),AppErrorCodes.CreateQuoteController_MenuTransferError);
                                        });
                            },
                            function quoteDataNotReadyErr(err){
                                $rootScope.$broadcast(quoteCreationEvents.sendIntegration,{complete: true});
                                throw new TLCError(new Error(err),AppErrorCodes.CreateQuoteController_MenuTransferError);
                            }
                        );

                },
                5000 //waiting 5 seconds before we ship off integration..giving time for other "clicks" to be bundled up
            );
        };

        $scope.$on(quoteCreationEvents.sendIntegration, function(event, args) {
            $scope.showQueuingIntegration = false;
            $scope.showSendingIntegration = true;
            $timeout(function() { $scope.showSendingIntegration = false; }, 1500);//after 3 seconds, stop showing
        });

        $scope.$on(quoteCreationEvents.queueUpIntegration, function(event, args) {
            $scope.showSendingIntegration = false;
            $scope.showQueuingIntegration = true;
            $timeout(function() { $scope.showQueuingIntegration = false; }, 1500);//after 3 seconds, stop showing
        });

        $scope.$on('ContractFieldsCompleted', function(event, args){
            $scope.isAllPerformancePointsSectionReady = args.completed;
        })


        function CheckGap() {
            var isProdGap = false;

           for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
                if ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('GAP') > -1)
                ||   ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode != null)
                        && (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('GAP') > -1)))
                {
                    isProdGap = true;
                    break;
                }

            }
            //console.log(isProdGap.toString());
            return isProdGap;
        }

        /* The Check methods - when key, etch products are removed from the quote queue, the respective preflt field need not show,
         the only way I know to evaluate product type is to implement Check methods */
        function CheckKey() {
            var isProdKey = false;
            var quoteid = "";
            var rateChecked = false;

            for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
                if ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('KEYCARE') > -1)
                    ||   ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode != null)
                        && (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('KEYCARE') > -1)))
                {
                    isProdKey = true;
                    quoteid =contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedTerms[0].SavedRateUniqueId;
                    rateChecked = IsRateTermChecked (quoteid);
                    break;
                }

            }

           return isProdKey && rateChecked;
        }

       function CheckEtch() {
        //$scope.CheckEtch = function(){
            var isProdEtch = false;
            var quoteid = "";
            var rateChecked = false;

            for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {

                if ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('ETCH') > -1)
                    ||   ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode != null)
                        && (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('ETCH') > -1)))
                {
                    isProdEtch = true;
                    quoteid =contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedTerms[0].SavedRateUniqueId;
                    rateChecked = IsRateTermChecked (quoteid);
                    break;
                }
            }
            return isProdEtch && rateChecked;
        };

        function CheckEtchSecNum() {
            var isProdEtch = false;
            var rateChecked = false;
            var quoteid = "";

            for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
                if ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('THEFT') > -1)
                    ||   ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode != null)
                        && (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('THEFT') > -1)))
                {
                    isProdEtch = true;
                    quoteid =contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedTerms[0].SavedRateUniqueId;
                    rateChecked = IsRateTermChecked (quoteid);
                    break;
                }

            }
            return isProdEtch && rateChecked;
        }

        function CheckEtchNum() {
            var isProdEtch = false;
            var rateChecked = false;
            var quoteid = "";

            for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
                if ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('ETC') > -1)
                    ||   ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode != null)
                        && (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('ETC') > -1)))
                {
                    isProdEtch = true;
                    quoteid =contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedTerms[0].SavedRateUniqueId;
                    rateChecked = IsRateTermChecked (quoteid);
                    break;
                }

            }
            return isProdEtch && rateChecked;
        }

        function CheckProdEtch() {
            var isProdEtch = false;
            if (CheckEtch() || CheckEtchSecNum() || CheckEtchNum()) {
                isProdEtch = true;
            }

            return isProdEtch;
        }

        //KRE COM-1064
        function GetThftContractLabel() {
            // If product is THFT (Zurich)
            for (i = 0; i < contractInfoService.quoteQueueInfo.currentScenarioQuotes.length; i++) {
                if ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.DisplayName.toUpperCase().indexOf('THFT') > -1)
                    || ((contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode != null)
                    && (contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct.PartnerCode.toUpperCase().indexOf('THFT') > -1))) {
                    var p = contractInfoService.quoteQueueInfo.currentScenarioQuotes[i].RatedProduct;
                    var contractLabel =  getFlexField(p, 'CONTRACT-LABEL');
                    return contractLabel || 'THEFT ID';  // Default should not occur here.
                }
            }
            return null;
        }

        function GetActiveView(missingInfoViewComplete, lenderInfoViewComplete, performancePointViewComplete) {
            var newActiveView;
            if (missingInfoViewComplete)
                if (lenderInfoViewComplete)
                    if (performancePointViewComplete) //all data is present for all views, default to transaction Info view
                        newActiveView = $scope.preflightViews.missingInfo;
                    else
                    newActiveView = $scope.preflightViews.performancePoint;
                else
                    newActiveView = $scope.preflightViews.lenderView;
            else
                newActiveView = $scope.preflightViews.missingInfo;
            return newActiveView;
        };

        function getSelectTextPerformancePoint()
        {
            if((contractInfoService.requiredFields.contract.indexOf('performancePoints') >= 0) || (contractInfoService.requiredFields.contract.indexOf('performancePoints1') >= 0)
                || (contractInfoService.requiredFields.contract.indexOf('performancePoints2') >= 0)
                || (contractInfoService.contractProductInfo.performancePoints!=undefined && contractInfoService.contractProductInfo.performancePoints.length > 0)
                || (((contractInfoService.contractProductInfo.performancePoints1 != null || contractInfoService.contractProductInfo.performancePoints1 != undefined) && contractInfoService.contractProductInfo.performancePoints1.length > 0)
                && ((contractInfoService.contractProductInfo.performancePoints2 != null || contractInfoService.contractProductInfo.performancePoints2 != undefined) && contractInfoService.contractProductInfo.performancePoints2.length > 0)))
            {
                $scope.isPerformancePointsSelectTextEnabled = true;
            }
        }

        function getEnabledPrFltFields()
        {  //new requirement to always open preflt regardless of data completion, we lose variables in the contractInfoService.requiredFields.contract model ("shouldEnable"  methods)
            //so if user opens preflt, fills in all data, closes preflt, then reopens, the provider specific fields will not show b/c the api validates these fields
            // as valid and will not push onto the contractInfoService.requiredFields.contract model, but we can also determine by evaluating the contractProductInfo model
            if ($scope.contractProductInfo.amountFinanced != "" && $scope.contractProductInfo.amountFinanced != undefined && $scope.IsGap){
                   $scope.isAmountFinancedEnabled = true;
            }

            if ($scope.contractProductInfo.etchStencilNum != "" && $scope.contractProductInfo.etchStencilNum != undefined
                                                                && $scope.contractProductInfo.etchStencilNum != null && $scope.IsEtch ){
                $scope.isEtchStencilNumEnabled = true;
            }
            if ($scope.contractProductInfo.etchNum != "" && $scope.contractProductInfo.etchNum != undefined
                                                         && $scope.contractProductInfo.etchNum != null && $scope.IsEtch){
                $scope.isEtchNumEnabled = true;
            }
            if ($scope.contractProductInfo.etchSecNum != "" && $scope.contractProductInfo.etchSecNum != undefined
                                                            && $scope.contractProductInfo.etchSecNum != null && $scope.IsEtch){
                $scope.isEtchSecNumEnabled = true;
            }
            if ($scope.contractProductInfo.keycareContractNum != "" && $scope.contractProductInfo.keycareContractNum != undefined
                                                                    && $scope.contractProductInfo.keycareContractNum != null && $scope.IsKey){
                $scope.isKeycareContractNumEnabled = true;
            }
        }

         $scope.clearNames = function() {
            $scope.customerDefinition.BuyerInfo.firstName = '';
            $scope.customerDefinition.BuyerInfo.middleName = '';
            $scope.customerDefinition.BuyerInfo.lastName = '';
            $scope.customerDefinition.CoBuyerInfo.firstName = '';
            $scope.customerDefinition.CoBuyerInfo.middleName = '';
            $scope.customerDefinition.CoBuyerInfo.lastName = '';
            $scope.customerDefinition.BusinessInfo.businessName = '';
            $scope.customerDefinition.BusinessInfo.driverFirstName = '';
            $scope.customerDefinition.BusinessInfo.driverLastName = '';
        };

        $scope.clearPrFltCustomFields = function(rate){
            //When we remove the product from q, clear out values for our provider custom field, else
            //if we add product again,  which will add the respective field again, the data is persisted
            //from the user's last input
            if(rate.RatedProduct.DisplayName.toUpperCase().indexOf('KEYCARE') > -1) {
                $scope.contractProductInfo.keycareContractNum = '';
            }

            if(rate.RatedProduct.DisplayName.toUpperCase().indexOf('ETC') > -1 || rate.RatedProduct.DisplayName.toUpperCase().indexOf('THEFT') > -1
                                || rate.RatedProduct.DisplayName.toUpperCase().indexOf('ETCH') > -1) {
                $scope.contractProductInfo.etchStencilNum = '';
                $scope.contractProductInfo.etchNum = '';
                $scope.contractProductInfo.etchSecNum = '';
            }

        };

        function IsRateTermChecked (quoteid) {
           var x = contractInfoService.quoteQueueInfo.statuses[quoteid];
            if (x.draftChecked || x.officialChecked )
                return true;
            return false;
        };

          $scope.shouldShowNameFields = function() {
            return $scope.shouldEnableBusinessNameFields()
                || $scope.shouldEnablePersonalNameFields();
        };

        $scope.shouldEnableBusinessNameFields = function() {
            return ['BusinessInfo.businessName', 'BusinessInfo.driverFirstName', 'BusinessInfo.driverLastName'].some(function(field) {
                return contractInfoService.requiredFields.customer.indexOf(field) >= 0
                    || (contractInfoService.validFields.customer.indexOf(field) >= 0 && override());
            });
        };

        $scope.shouldEnablePersonalNameFields = function() {
            return ['BuyerInfo.firstName', 'BuyerInfo.lastName'].some(function(field) {
                return contractInfoService.requiredFields.customer.indexOf(field) >= 0
                    || (contractInfoService.validFields.customer.indexOf(field) >= 0 && override());
            });
        };


        $scope.shouldEnableKeycareField = function() {
            return contractInfoService.requiredFields.contract.indexOf('keycareContractNum') >= 0
                || (contractInfoService.validFields.contract.indexOf('keycareContractNum') >= 0 && override());
        }

        $scope.shouldEnableEtchStencilField = function() {
             return contractInfoService.requiredFields.contract.indexOf('etchStencilNum') >= 0
                || (contractInfoService.validFields.contract.indexOf('etchStencilNum') >= 0 && override());
        };

        $scope.shouldEnableEtchNumberField = function() {
            return contractInfoService.requiredFields.contract.indexOf('etchNum') >= 0
                || (contractInfoService.validFields.contract.indexOf('etchNum') >= 0 && override());
        };

        $scope.shouldEnableEtchSecurityNumberField = function() {
            return contractInfoService.requiredFields.contract.indexOf('etchSecNum') >= 0
                || (contractInfoService.validFields.contract.indexOf('etchSecNum') >= 0 && override());
        };

        $scope.shouldEnableAddressFields = function() {
            return ['address1','city','state','zip','phone1'].some(function(field) {
                return contractInfoService.requiredFields.customer.indexOf(field) >= 0
                    || (contractInfoService.validFields.customer.indexOf(field) >= 0 && override());
            });
        };

        $scope.shouldEnableSellingPrice = function() {
            return contractInfoService.requiredFields.deal.indexOf('sellingPrice') >= 0
                || (contractInfoService.validFields.deal.indexOf('sellingPrice') >= 0 && override());
        };

        $scope.shouldEnableAmountFinanced = function() {

            if (contractInfoService.requiredFields.contract.indexOf('amountFinanced') >= 0
                || (contractInfoService.validFields.contract.indexOf('amountFinanced') >= 0 && override()))
            {
                contractInfoService.contractProductInfo.amountFinanced = $scope.dealInfo.amountFinanced;
                return true;
            }
            else{ return false;}

        };


        $scope.shouldEnableRVFields = function() {
            var dealerVehicleType = erateSessionVarsService.getCurrentDealerVehicleType();
            var dlrRVSupported = (dealerVehicleType == vehicleTypeConstants.rv || dealerVehicleType == vehicleTypeConstants.rvAndAuto) ? true : false;
            if (!dlrRVSupported)
                return false;
            else{
                return ((contractInfoService.requiredFields.vehicle.indexOf('makeName') >= 0 ||
                    contractInfoService.requiredFields.vehicle.indexOf('modelName') >= 0 ||
                    contractInfoService.requiredFields.vehicle.indexOf('vin') >= 0))
                    || ((contractInfoService.requiredFields.vehicle.indexOf('makeName') >= 0 ||
                    contractInfoService.requiredFields.vehicle.indexOf('modelName') >= 0 ||
                    contractInfoService.requiredFields.vehicle.indexOf('vin') >= 0)
                    && override());
            }
        };

        $scope.isAllMissingInfoReady = function(){
            return ( ($scope.shouldEnablePersonalNameFields && $scope.selectedCustomerType == $scope.customerTypes.personal ?  ['firstName', 'lastName'].every(function(field) {
                return  $scope.customerDefinition.BuyerInfo[field] != '';
            }) : true ) &&
            ($scope.shouldEnableBusinessNameFields && $scope.selectedCustomerType == $scope.customerTypes.business ?  ['businessName','driverFirstName', 'driverLastName'].every(function(field) {
                return  $scope.customerDefinition.BusinessInfo[field] != '';
            }) : true ) &&
            ($scope.shouldEnableAddressFields ?  ['address1','city','state','zip','phone1'].every(function(field) {
                return  $scope.customerDefinition[field] != '';
            }) : true ) &&
            ((contractInfoService.requiredFields.contract.indexOf('keycareContractNum') >= 0) || $scope.isKeycareContractNumEnabled ?  ($scope.contractProductInfo['keycareContractNum'] != '' && $scope.contractProductInfo['keycareContractNum'] != undefined) : true ) &&
            ((contractInfoService.requiredFields.contract.indexOf('etchStencilNum') >= 0) || $scope.isEtchStencilNumEnabled ?  ($scope.contractProductInfo['etchStencilNum'] != '' && $scope.contractProductInfo['etchStencilNum'] != undefined) : true ) &&
            ((contractInfoService.requiredFields.contract.indexOf('etchNum') >= 0) || $scope.isEtchNumEnabled ?  ($scope.contractProductInfo['etchNum'] != '' && $scope.contractProductInfo['etchNum'] != undefined) : true ) &&
            ((contractInfoService.requiredFields.contract.indexOf('etchSecNum') >= 0) || $scope.isEtchSecNumEnabled ?  ($scope.contractProductInfo['etchSecNum'] != '' && $scope.contractProductInfo['etchSecNum'] != undefined) : true ) &&
                ($scope.shouldEnableSellingPrice ?  ['sellingPrice'].every(function(field) {
                return  $scope.dealInfo[field] != '' || $scope.dealInfo[field] != undefined;
            }) : true ) &&
            ($scope.shouldEnableRVFields ? (contractInfoService.requiredFields.vehicle.every(function(field) {
                return  ($scope.vehicleInfo[field] != '' && $scope.vehicleInfo[field] != null);
            })) : true ) &&
                ($scope.shouldEnableAmountFinanced() || $scope.isAmountFinancedEnabled ? ($scope.dealInfo['amountFinanced'] != undefined  && $scope.dealInfo['amountFinanced'] != "" && $scope.dealInfo['amountFinanced'] > 0) : true)
                && (($scope.dealInfo['sellingPrice'] != undefined  && $scope.dealInfo['sellingPrice'] != "" && $scope.dealInfo['sellingPrice'] > 0))
            )
        };


        $scope.assignCustomFieldValFabPreflt = function(){

            //Let's tlcapi know our provider-specific field on preflight has been entered
             if (contractInfoService.requiredFields.contract.indexOf('amountFinanced') >= 0){
                $scope.contractProductInfo.amountFinanced = $scope.dealInfo.amountFinanced;
            }
            contractInfoService.contractProductInfo.amountFinanced = $scope.dealInfo.amountFinanced;
        }

        /*$scope.isAllPerformancePointsSectionReady = function() {
            return ((contractInfoService.requiredFields.contract.indexOf('performancePoints') >= 0) ?  ($scope.contractProductInfo['performancePoints'] != '') : true )
        }*/

        $scope.shouldEnablePerformancePointsSelect = function() {
            return $scope.performancePointUIMode.toUpperCase() === 'SELECT' &&
                contractInfoService.requiredFields.contract.indexOf('performancePoints') >= 0
                || (contractInfoService.validFields.contract.indexOf('performancePoints') >= 0 && override());
        };

        $scope.shouldEnablePerformancePointsText = function() {
            return $scope.performancePointUIMode.toUpperCase() === 'TEXT' &&
                contractInfoService.requiredFields.contract.indexOf('performancePoints') >= 0
                || (contractInfoService.validFields.contract.indexOf('performancePoints') >= 0 && override())
                || // OR f&IMangerFirst and Last Names are required
                (contractInfoService.requiredFields.contract.indexOf('performancePoints1') >= 0
                || (contractInfoService.validFields.contract.indexOf('performancePoints1') >= 0 && override()))
            &&
                (contractInfoService.requiredFields.contract.indexOf('performancePoints2') >= 0
                    || (contractInfoService.validFields.contract.indexOf('performancePoints2') >= 0 && override())
                )
        };

        $scope.shouldEnablePhone = function() {
            return contractInfoService.requiredFields.customer.indexOf('phone1') >= 0
                || (contractInfoService.validFields.customer.indexOf('phone1') >= 0 && override());
        }

        $scope.lookupCustomerDefinitionLocationByZipCode = function(zipCode) {
            locationService.getLocationInfoFromZipCode(zipCode)
                .then(function(data) {
                    _.extend($scope.customerDefinition, data);
                });
        };
        $scope.getPerfPointsUIMode = function(){
            contractCreationService.getPerformancePointsMode()
                .then(
                    function(mode) {
                        $scope.performancePointUIMode = mode;
                    }
                );
        }

        $scope.customerTypes = { personal : "personal", business : "business" };
        $scope.selectedCustomerType = $scope.shouldEnablePersonalNameFields() ? $scope.customerTypes.personal : ($scope.shouldEnableBusinessNameFields() ? $scope.customerTypes.business : 'None');
        if ($scope.selectedCustomerType == 'None')
            $scope.selectedCustomerType = ($scope.customerDefinition.BuyerInfo.firstName || $scope.customerDefinition.BuyerInfo.lastName) ? $scope.customerTypes.personal : (($scope.customerDefinition.BusinessInfo.driverFirstName || $scope.customerDefinition.BusinessInfo.driverLastName) ? $scope.customerTypes.business : 'None');
        $scope.performancePointUIMode = 'OFF';
        $scope.init();
    }
]);
